/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Helmet from 'react-helmet';
import Sidebar from '../../components/SidebarBlogue';
import s from './Blogue.css';
import HeightMatchingGroup from 'react-height-matching-group';
import { Link } from 'react-router';

const title = 'Blogue';

@withStyles(s)
export default class Blogue extends Component {

    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            loader: true,
        };
    }

    componentDidMount() {

        this.GetPosts();
    }

    async GetPosts() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{posts{id, slug, title, titlePost, content, excerpt, thumbnail, categories{id, slug, name}, date, authorName, authorAvatar}}',
                slug: 'test',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.posts) throw new Error('Erreur sur le chargement des posts !');

        if(data){
            this.setState({ loader: false })
        }

        this.setState({ posts: data.posts })
    }

    render() {
        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#00bf43'
        }

        return (
            <div className={s.root}>
                <Helmet title={title} />
                <div className={`spinner ${appear}`} style={background} ></div>
                <div id="blogue" className={`blogue`}>
                    <div className={`bgHeader`}></div>
                    <main role="main">
                        <div className={`container`}>
                            <h1 className={`titrePage`}><Link to={`/blogue`}>{title}</Link></h1>   
                            <div className={`col-md-8`}>
                               <div className={`wrapArticles`}>
                                    <div className={`articles`}>
                                        <HeightMatchingGroup tagName="ul" selector=".match">
                                        {this.state.posts.slice(0, 1).map((item, index) => (
                                            <li key={index} className={`boxArticle`}>
                                                <div className={`content`}>
                                                    <div className={`thumbBlogue`}>
                                                        <Link to={`/blogue/${item.slug}`}>
                                                            <img src={item.thumbnail} alt="Image article" />
                                                        </Link>
                                                        <div className={`wrapCatArticle`}>
                                                            {item.categories.map((cat, index) => (
                                                                <span key={index} className={`catArticle`}>
                                                                    <Link to={`/blogue/categorie/${cat.slug}`}>{cat.name}</Link>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <span className={`titreArticle`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                                    </Link>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <div className={`excerptArticle`}>
                                                            <p>{item.excerpt}</p>
                                                            <span className={`lireSuite`}>Lire la suite ...</span>
                                                        </div>
                                                    </Link>
                                                    <div className={`auteurArticle`}>
                                                        <div className={`thumbAuteur`}>
                                                            <div dangerouslySetInnerHTML={{ __html: item.authorAvatar }} />
                                                        </div>
                                                        <span className={`nomAuteur`}>{item.authorName}</span>
                                                        <span className={`dateArticle`}>{item.date}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                        {this.state.posts.slice(1).map((item, index) => (
                                            <li key={index} className={`boxArticle match`}>
                                                <div className={`content`}>
                                                    <div className={`thumbBlogue`}>
                                                        <Link to={`/blogue/${item.slug}`}>
                                                            <img src={item.thumbnail} alt="Image article" />
                                                        </Link>
                                                        <div className={`wrapCatArticle`}>
                                                        {item.categories.map((cat, index) => (
                                                            <span key={index} className={`catArticle`}>
                                                                <Link to={`/blogue/categorie/${cat.slug}`}>{cat.name}</Link>
                                                            </span>
                                                        ))}
                                                        </div>
                                                    </div>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <span className={`titreArticle`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                                    </Link>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <div className={`excerptArticle`}>
                                                            <p>{item.excerpt}</p>
                                                            <span className={`lireSuite`}>Lire la suite ...</span>
                                                        </div>
                                                    </Link>
                                                    <div className={`auteurArticle`}>
                                                        <div className={`thumbAuteur`}>
                                                            <div dangerouslySetInnerHTML={{ __html: item.authorAvatar }} />
                                                        </div>
                                                        <span className={`nomAuteur`}>{item.authorName}</span><br />
                                                        <span className={`dateArticle`}>{item.date}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                        </HeightMatchingGroup>
                                    </div>
                                </div>
                            </div>
                            <div className={`col-md-4`}>
                                <div className={`sidebar`}>
                                    <div className={`content`}>
                                        <Sidebar />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/blogue/Blogue.js